import React, { useState } from 'react'
import PageHeader from '../Shared/PageHeader'
import html from '../../assets/skills/html.png'
import css from '../../assets/skills/css.png'
import js from '../../assets/skills/js.png'
import tailwind from '../../assets/skills/tailwind.png'
import bootstrap from '../../assets/skills/bootstrap.png'
import node from '../../assets/skills/nodejs.png'
import express from '../../assets/skills/express.png'
import mongodb from '../../assets/skills/mongodb.png'
import reactjs from '../../assets/skills/reactjs.png'

const CDN = 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons'

const skills = [
  { img: reactjs, name: 'React Js' },
  { img: `${CDN}/nextjs/nextjs-original.svg`, name: 'Next Js' },
  { img: `${CDN}/typescript/typescript-original.svg`, name: 'TypeScript' },
  { img: js, name: 'Javascript' },
  { img: tailwind, name: 'Tailwind' },
  { img: node, name: 'Node Js' },
  { img: express, name: 'Express Js' },
  { img: 'https://ui.shadcn.com/apple-touch-icon.png', name: 'Shadcn UI' },
  { img: `${CDN}/chakraui/chakraui-original.svg`, name: 'Chakra UI' },
  { img: `${CDN}/postgresql/postgresql-original.svg`, name: 'PostgreSQL' },
  { img: `${CDN}/mysql/mysql-original.svg`, name: 'MySQL' },
  { img: `${CDN}/redis/redis-original.svg`, name: 'Redis' },
  { img: mongodb, name: 'MongoDB' },
  { img: html, name: 'HTML' },
  { img: css, name: 'CSS' },
  { img: bootstrap, name: 'Bootstrap' },
]

const SkillCard = ({ skill, index }) => {
  const [hovered, setHovered] = useState(false)

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px 8px',
        minHeight: '110px',
        borderRadius: '12px',
        border: hovered
          ? '1px solid rgba(250,204,21,0.65)'
          : '1px solid rgba(250,204,21,0.14)',
        background: hovered
          ? 'linear-gradient(135deg, rgba(250,204,21,0.1), rgba(250,204,21,0.03))'
          : 'linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01))',
        boxShadow: hovered
          ? '0 0 28px rgba(250,204,21,0.22), 0 6px 24px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.07)'
          : '0 0 12px rgba(250,204,21,0.07), inset 0 1px 0 rgba(255,255,255,0.04)',
        transform: hovered ? 'scale(1.10) translateY(-5px)' : 'scale(1)',
        transition: 'all 0.32s cubic-bezier(0.34,1.56,0.64,1)',
        cursor: 'pointer',
        animation: `fadeSlideUp 0.4s ease both`,
        animationDelay: `${index * 0.04}s`,
      }}
    >
      {/* always-on glow ring */}
      <span style={{
        position: 'absolute',
        inset: 0,
        borderRadius: '12px',
        boxShadow: hovered
          ? '0 0 0 2px rgba(250,204,21,0.4)'
          : '0 0 0 1px rgba(250,204,21,0.08)',
        pointerEvents: 'none',
        transition: 'box-shadow 0.3s ease',
        animation: hovered ? 'pulse-ring 1s ease-out infinite' : 'none',
      }} />

      <img
        src={skill.img}
        alt={skill.name}
        style={{
          width: '48px',
          height: '48px',
          objectFit: 'contain',
          marginBottom: '10px',
          borderRadius: '6px',
          filter: hovered
            ? 'grayscale(0%) drop-shadow(0 0 10px rgba(250,204,21,0.45))'
            : 'grayscale(20%) brightness(0.85)',
          transition: 'filter 0.32s ease',
        }}
      />

      <p style={{
        fontSize: '10px',
        letterSpacing: '0.1em',
        fontWeight: 700,
        textTransform: 'uppercase',
        color: hovered ? '#facc15' : '#9ca3af',
        textShadow: hovered ? '0 0 10px rgba(250,204,21,0.5)' : 'none',
        transition: 'color 0.3s ease, text-shadow 0.3s ease',
        textAlign: 'center',
        margin: 0,
      }}>
        {skill.name}
      </p>
    </div>
  )
}

const Skills = () => (
  <div>
    <PageHeader title='Skills' />
    <div className='grid pt-10 pb-5 grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4'>
      {skills.map((skill, i) => (
        <SkillCard key={i} skill={skill} index={i} />
      ))}
    </div>
  </div>
)

export default Skills
